<template>
  <div>
    <div class="w-full flex justify-between items-start">
      <Lynx-Title text="Agendamentos" />

      <Lynx-Button
        text="Atualizar Planilha"
        class="bg-primary-600 text-neutral-100 pl-2"
        style="margin-top: 10px"
        icon-size="4"
        icon="Reload"
        size="small"
        outlined="true"
        @click.native="fetchAgendamentos"
      />
    </div>

    <div class="flex flex-col">
      <div class="w-full flex justify-end pb-6">
        <div class="flex gap-4 w-3/4">
           <label class="w-1/4">
            <Lynx-Label label="ID Empresas" class=" " />

            <input
              class="border-primary-200 bg-white px-2 border-l-4 border-solid rounded py-1 w-full transition focus:shadow focus:border-r-4 font-light"
              v-model="empresas_id"
              v-on:keyup.enter="fetchAgendamentos"
            />
          </label>
           <label class="w-1/5">
          <Lynx-Label label="Seleciona um período" />
          <b-datepicker
            v-model="filtros.competencia"
            placeholder="Seleciona um período"
            :date-parser="(date) => new Date(date)"
            :month-names="monthNames"
            :day-names="dayNames"
            :years-range="[-3, 3]"
            range
          >
            <b-button
              label="Clear"
              type="is-danger"
              icon-left="close"
              outlined
              @click="filtros.competencia = null"
            />
          </b-datepicker>
        </label>
          <label class="w-1/4">
            <Lynx-Label label="Cidades" class=" " />

            <v-autocomplete
              :loading="loadingCidades"
              v-model="filtros.cidades"
              :items="lista_cidades"
              :search-input.sync="searchQuery"
              label="Selecione a(s) cidades(s)"
              multiple
              dense
              item-text="nome"
              item-value="id"
              @change="clearSearchQuery"
            >
            </v-autocomplete>
          </label>
           <label class="w-1/3">
          <Lynx-Label label="Carteiras" class=" " />
          <treeselect
            :multiple="true"
            :options="lista_carteiras"
            placeholder="Selecione a(s) carteiras(s)"
            v-model="filtros.carteiras"
          />
        </label>
        </div>
    
      </div>
      <div class="w-full flex justify-end pb-6">

          <label >
          <Lynx-Label label="Itens por página" />

          <b-select v-model="filtros.perPage">
            <option
              :value="perPageOption"
              v-for="perPageOption in perPageOptions"
              :key="perPageOption"
            >
              {{ perPageOption }}
            </option>
          </b-select>
        </label>
      </div>
    </div>

    <div class="table-container">
      <b-table
        :data="Agendamentos"
        :columns="colunas"
        hoverables
        paginated
        default-sort-direction="asc"
        default-sort="id"
        :loading="loading"
        backend-pagination
        @page-change="onPageChange"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        :total="pagination.total"
        :current-page="pagination.current_page"
        :per-page="pagination.per_page"
        striped
        style="font-size: smaller"
        :style="tamanhoTela"
        detailed
        detail-key="id"
        :detail-transition="transitionName"
        :opened-detailed="defaultOpenedDetails"
        @details-open="(row, index) => fecharTodos(row, index)"
      >
        <template slot-scope="props">
          <b-table-column
            field="id"
            v-text="props.row.id"
            style="
              width: 30px;
              position: sticky;
              left: 0;
              background-color: #fff;
              z-index: 1;
              background-color: #031127;
              color: white;
            "
          />
          <b-table-column
            field="cnpj"
            v-text="props.row.cnpj"
            style="
              width: 90px;
              position: sticky;
              left: 100px;
              background-color: #fff;
              z-index: 2;
              background-color: #031127;
              color: white;
            "
          />
          <b-table-column
            field="razao_social"
            v-text="props.row.razao_social"
            style="width: 220px"
          />
          <b-table-column field="inicio_atividades" style="width: 120px">
            {{ formatEnToBr(props.row.inicio_atividades)  }}</b-table-column
          >

          <b-table-column style="width: 120px" field="carteiras">
            {{ props.row.carteiras }}
          </b-table-column>
           <b-table-column style="width: 120px" field="agendamentos">
            {{ props.row.agendamentos }}
          </b-table-column>
       

          <!-- <b-table-column style="width: 80px" field="endereco.uf">
            <span v-if="props.row.endereco">
              {{ props.row.endereco.uf }}
            </span>
            <span v-if="props.row.endereco">
              {{ props.row.endereco.cidade }}
            </span>
          </b-table-column> -->
   
   
        
     
        </template>
        <template slot="detail" slot-scope="props">
          <ContasReceber
            @listarAgendamentos="fetchAgendamentos()"
            :empresa="props.row"
          />
        </template>
        <template v-slot:empty>
          <NotFoundData text="Nenhum Agedamento registrado!" />
        </template>
      </b-table>

      <div class="float-left" style="margin-top: -60px" v-if="!loading">
        <b-pagination
          :total="pagination.total"
          :current.sync="current_page"
          :per-page="pagination.per_page"
        />
      </div>
    </div>

    <!-- <b-modal :active.sync="createModal" v-if="createModal" width="500px">
      <Create-Taxa @create-taxa="onCreateContasReceber" />
    </b-modal> -->
  </div>
</template>

<script>
import ContasReceber from "@/views/financeiro/agendamentos/ContasReceber.vue";
// import EditTaxa from "@/views/empresas/taxasAlvaras/Edit";
// import CreateTaxa from "@/views/empresas/taxasAlvaras/Create";
import NotFoundData from "@/components/layouts/NotFoundData";
import moment from "moment";
import { monthNames, dayNames } from "@/utils/utils";
import LynxTextarea from "@/components/helpers/Textarea";
import Treeselect from "@riophae/vue-treeselect";
import { mapGetters } from "vuex";
import { showCidadesRequest } from "@/services/requests/estados";
import { hasRole } from "@/utils/can";

export default {
  name: "EmpresasAlvarasIndex",
  components: {
    NotFoundData,
    Treeselect,
    LynxTextarea,
    ContasReceber,
  },
  data() {
    return {
      monthNames,
      dayNames,
      moment,
      loading: false,
      loadingCidades: false,
      carteira: null,
      carteiras: [],
      empresas_id: null,
      perPageOptions: [10, 50, 100],
      current_page: 1,
      empresas_id: null,
      loadingInicial: false,
      searchQuery: null,
      lista_cidades: [],
      defaultOpenedDetails: [],
      filtros: {
        page: 1,
        perPage: 10,
        empresas_id: null,
        competencia: null,
        carteiras: [],
        cidades: [],
      },
      empresas_id:null,
      colunas: [
        { field: "id", label: "ID" },
        { field: "cnpj", label: "CNPJ" },
        { field: "razao_social", label: "Empresa" },
        { field: "inicio_atividades", label: "Data inicio" },
        { field: "carteiras", label: "Carteiras" },
        { field: "agendamentos", label: "agendamentos" },
      ],
    };
  },

  computed: {
    ...mapGetters(["getToken"]),
    lista_carteiras() {
      let carteira = Object.values(this.$store.state.carteira.lista_carteiras);
      let data = [];
      for (let i = 0; i < carteira.length; i++) {
        if (carteira[i].setor == "contabilidade") {
          data.push({ id: carteira[i].id, label: carteira[i].nome });
        }
      }
      for (let i = 0; i < carteira.length; i++) {
        if (
          carteira[i].setor == "onboarding" &&
          carteira[i].nome != "Onboarding"
        ) {
          data.push({ id: carteira[i].id, label: carteira[i].nome });
        }
      }
      return data;
    },
    lista_empresas_contas_receber(){
      return this.$store.state.contasReceber.lista_empresas_contas_receber
    },
    Agendamentos() {
      return this.lista_empresas_contas_receber.data;
    },
    pagination() {
      return this.lista_empresas_contas_receber.pagination;
    },
    tamanhoTela() {
      const tamanhoFixo = this.calcularTamanhoTabela();
      const larguraTela =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      const tamanhoRelativo = (tamanhoFixo / larguraTela) * 100;
      const tamanhoFinal = tamanhoRelativo;
      return `width:${tamanhoFinal}vw;`;
    },
  },
  watch: {
    "filtros.status_alvara"() {
      this.filtros.tipo_alvara = "alvara";
    },
    "filtros.perPage"() {
      this.fetchAgendamentos();
    },
    current_page() {
      this.filtros.page = this.current_page;
      this.fetchAgendamentos();
    },
    searchQuery: _.debounce(function () {
      if (this.searchQuery.length > 3) {
        this.searchCidades();
      }
    }, 400),
  },
  methods: {
    hasRole,
    fetchAgendamentos() {
 
      this.loading = true;
      if (this.empresas_id) {
        this.filtros.empresas_id = this.empresas_id.split(",");
      } else {
        this.filtros.empresas_id = null;
      }
      const { filtros } = this;
      this.$store
        .dispatch("contasReceber/listar_empresas_contas_receber", filtros)
        .finally(() => {
          this.loading = false;
        });
    },

    // onEditAgendamentos() {
    //   this.fetchAgendamentos();
    //   this.editModal = false;
    // },
    // onCreateAgendamentos() {
    //   this.fetchAgendamentos();
    //   this.createModal = false;
    // },

    onPageChange(page) {
      this.current_page = page;
    },

    calcularTamanhoTabela() {
      let totalWidth = 0;
      this.colunas.map((column) => {
        switch (column.field) {
          case "id":
            totalWidth += 80;
            break;

          case "razao_social":
            totalWidth += 300;
            break;

          default:
            totalWidth += 200;
            break;
        }
      });
      totalWidth += 100;

      return totalWidth;
    },
    async fetchCarteiras() {
      await this.$store.dispatch("carteira/listar_carteiras");
    },

    clearSearchQuery() {
      this.searchQuery = "";
    },
    searchCidades() {
      this.loadingCidades = true;

      showCidadesRequest(this.searchQuery)
        .then((res) => {
          this.lista_cidades = res.data.map((item) => {
            return {
              id: item.id,
              nome: item.nome + "-" + item.estado.uf,
            };
          });
        })
        .finally(() => (this.loadingCidades = false));
    },

    transitionName() {
      if (this.useTransition) {
        return "fade";
      }
    },
    fecharTodos(row, index) {
      this.defaultOpenedDetails = [row.id];
    },

    formatEnToBr(date) {
      const momentDate = moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");

      if (momentDate != "Invalid date") {
        return momentDate;
      } else {
        return "sem data";
      }
    },
  },

  beforeMount() {
    this.fetchAgendamentos();
    this.fetchCarteiras();
  },
};
</script>
<style scoped>
.table-container {
  overflow-x: auto;
  width: 100%;
}
</style>

  
